export const JWT_EXPIRES_IN = '24d';

export function parseDuration(str: string): number {
  const match = str.match(/^(\d+)([smhd])$/);
  if (!match) return 3600000;
  const [, value, unit] = match;
  const num = parseInt(value, 10);
  const mul: Record<string, number> = {
    s: 1000,
    m: 60_000,
    h: 3_600_000,
    d: 86_400_000,
  };
  return num * (mul[unit] ?? 1000);
}

export const SESSION_TIMEOUT_MS = parseDuration(JWT_EXPIRES_IN)
